let contexto = null

export function definirContextoAntecessor(origemId, antecessorId) {
    if (origemId && antecessorId && String(origemId) !== String(antecessorId)) {
        contexto = {
            origemId: String(origemId),
            antecessorId: String(antecessorId),
        }
        return
    }
    contexto = null
}

export function contextoAntecessorAtual() {
    return contexto
}

export function aplicarHeadersAntecessor(headers) {
    if (!headers) return headers

    if (contexto) {
        headers['X-Projeto-Origem'] = contexto.origemId
        headers['X-Projeto-Antecessor'] = contexto.antecessorId
        return headers
    }

    if (typeof headers.delete === 'function') {
        headers.delete('X-Projeto-Origem')
        headers.delete('X-Projeto-Antecessor')
        return headers
    }

    delete headers['X-Projeto-Origem']
    delete headers['X-Projeto-Antecessor']
    return headers
}
